module.exports = __webpack_public_path__ + "static/media/icon-filter.194a5447.svg";